<template>
	<div>
		<div class="first_line">
			<el-button type="primary" size="small" @click="edtiInit()">新建班组</el-button>
		</div>
		<div>
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
				:data="rosterGroupList" tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="title" label="班组名称"></el-table-column>
				<el-table-column prop="rosterDesc" label="班次"></el-table-column>
				<el-table-column prop="storeTitle" label="适用门店"></el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						{{scope.row.status==1?"使用中":""}}
						{{scope.row.status==2?"已失效":""}}
					</template>
				</el-table-column>
				<el-table-column width="180" label="操作">
					<template slot-scope="scope">
						<!-- <div v-if="scope.row.status==1"> -->
						<el-button type="text" @click="edtiInit(scope.row)">编辑</el-button>
						<el-button type="text" @click="invalid(scope.row.id, 2)" style="color: #ff6c6c"
							v-if="scope.row.status==1">失效</el-button>
						<span style="color: #AAAAAA;position: relative;left:10px;" v-if="scope.row.status==2">已失效</span>
						<!-- </div> -->
						<!-- <div v-if="scope.row.status==2">
							<span style="color: #AAAAAA;position: relative;left:-10px;">已失效</span>
							<el-button type="text" @click="del(scope.row.id)" >
								<span style="color: red;">删除</span>b
							</el-button>
						</div> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- <div class="pagescg">
				<el-pagination
					@current-change="handleCurrentChange"
					:current-page="filter.pageNum"
					layout="total, sizes, prev, pager, next, jumper"
					:total="filter.total">
				</el-pagination>
			</div> -->
		</div>
		<el-dialog title="班姐" :visible.sync="editWindow" width="50%">
			<div>
				<span style="font-size:18px; font-weight:600">班组名称：</span>
				<el-input style="display:inline-block; width: 300px;" size="small"
					v-model="rosterGroup.title"></el-input>
			</div>
			<div>
				<span style="font-size:18px; font-weight:600">选择班次：</span>
				<el-checkbox-group v-model="rosterGroup.rosters" style="margin-left: 40px">
					<span v-for="i in rosterList" :key="i.id" style="display:inline-block; width: 100px;">
						<el-checkbox :label="i.id+''">{{ i.desc }}</el-checkbox>
					</span>
				</el-checkbox-group>
			</div>
			<div>
				<span style="font-size:18px; font-weight:600">选择门店：</span>
				<el-checkbox-group v-model="rosterGroup.stores" style="margin-left: 40px">
					<span v-for="i in storeList" :key="i.id" style="display:inline-block; width: 180px;">
						<el-checkbox :label="i.id+''">{{ i.title }}</el-checkbox>
					</span>
				</el-checkbox-group>
			</div>
			<div style="margin-left: 70%">
				<el-button type="primary" @click="edit">保存</el-button>
				<el-button @click="editWindow = false">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				filter: {},
				rosterGroupList: [],
				storeList: [],
				rosterList: [],
				editWindow: false,
				rosterGroup: {
					id: undefined,
					title: undefined,
					rosters: [],
					stores: [],
				}
			};
		},
		mounted() {
			this.init();
		},
		methods: {
			edtiInit(obj) {
				this.editWindow = true;
				if (obj) {
					this.rosterGroup = JSON.parse(JSON.stringify(obj));
				} else {
					this.rosterGroup = {
						id: undefined,
						title: undefined,
						rosters: [],
						stores: [],
					}
				}
			},
			edit() {
				this.rosterGroup.rosters = this.rosterGroup.rosters.toString();
				this.rosterGroup.stores = this.rosterGroup.stores.toString();
				this.$http.post("dcheckuser/editRosterGroup", JSON.stringify(this.rosterGroup)).then(res => {
					if (res.body.code == 200) {
						this.getList();
						this.editWindow = false;
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			invalid(id, status) {
				this.$http.get("dcheckuser/rosterGroup/invalid/" + id + "/" + status).then(res => {
					if (res.body.code == 200) {
						this.getList();
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			getList() {
				this.$http.post("dcheckuser/rosterGroupList", JSON.stringify(this.filter)).then(res => {
					this.rosterGroupList = res.body.data;
					this.rosterGroupList.map(rg => {
						// debugger
						let rosterDesc = [];
						rg.rosters = rg.rosters.split(',');
						rg.rosters.map(r => {
							let temp = this.rosterList.filter(ele => r == ele.id)
							if (temp) rosterDesc.push(temp[0].desc)
						});
						rg.rosterDesc = rosterDesc.toString();
						let storeTitle = [];
						rg.stores = rg.stores.split(',');
						rg.stores.map(r => {
							let temp = this.storeList.filter(ele => r == ele.id)
							if (temp) storeTitle.push(temp[0].title)
						});
						rg.storeTitle = storeTitle.toString();
					})
				})
			},
			init() {
				this.$http.get("store/list").then(res => {
					this.storeList = res.body.data
					this.$http.get("dcheckuser/allRoster").then(res => {
						this.rosterList = res.body.data;
						this.getList();
					});
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	.add {
		cursor: pointer;
		display: inline-block;
		border: 1px dashed #82848A;
		line-height: 2.5;
		padding: 8px;
		padding-top: 0px;
		padding-bottom: 0px;
		color: #82848A;
	}

	.first_line {
		margin: 20px 0;
		margin-top: 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.add_botom {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.add_botom_nei {
		margin-top: 15px;
		margin-left: 44%;
	}
</style>